/* tslint:disable */
/* eslint-disable */
/**
 * BloomRegistration.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitalPassportTrusteeMapping,
    DigitalPassportTrusteeMappingFromJSON,
    DigitalPassportTrusteeMappingFromJSONTyped,
    DigitalPassportTrusteeMappingToJSON,
} from './DigitalPassportTrusteeMapping';

/**
 * 
 * @export
 * @interface DigitalPassport
 */
export interface DigitalPassport {
    /**
     * 
     * @type {string}
     * @memberof DigitalPassport
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DigitalPassport
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DigitalPassport
     */
    imageUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitalPassport
     */
    data?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitalPassport
     */
    applePassUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitalPassport
     */
    applePassAuthenticationToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitalPassport
     */
    applePassIdenitifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitalPassport
     */
    applePassSerialNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitalPassport
     */
    googlePassUrl?: string | null;
    /**
     * 
     * @type {Array<DigitalPassportTrusteeMapping>}
     * @memberof DigitalPassport
     */
    digitalPassportTrusteeMappings?: Array<DigitalPassportTrusteeMapping> | null;
}

export function DigitalPassportFromJSON(json: any): DigitalPassport {
    return DigitalPassportFromJSONTyped(json, false);
}

export function DigitalPassportFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitalPassport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'imageUrl': !exists(json, 'imageUrl') ? undefined : json['imageUrl'],
        'data': !exists(json, 'data') ? undefined : json['data'],
        'applePassUrl': !exists(json, 'applePassUrl') ? undefined : json['applePassUrl'],
        'applePassAuthenticationToken': !exists(json, 'applePassAuthenticationToken') ? undefined : json['applePassAuthenticationToken'],
        'applePassIdenitifier': !exists(json, 'applePassIdenitifier') ? undefined : json['applePassIdenitifier'],
        'applePassSerialNumber': !exists(json, 'applePassSerialNumber') ? undefined : json['applePassSerialNumber'],
        'googlePassUrl': !exists(json, 'googlePassUrl') ? undefined : json['googlePassUrl'],
        'digitalPassportTrusteeMappings': !exists(json, 'digitalPassportTrusteeMappings') ? undefined : (json['digitalPassportTrusteeMappings'] === null ? null : (json['digitalPassportTrusteeMappings'] as Array<any>).map(DigitalPassportTrusteeMappingFromJSON)),
    };
}

export function DigitalPassportToJSON(value?: DigitalPassport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'isActive': value.isActive,
        'imageUrl': value.imageUrl,
        'data': value.data,
        'applePassUrl': value.applePassUrl,
        'applePassAuthenticationToken': value.applePassAuthenticationToken,
        'applePassIdenitifier': value.applePassIdenitifier,
        'applePassSerialNumber': value.applePassSerialNumber,
        'googlePassUrl': value.googlePassUrl,
        'digitalPassportTrusteeMappings': value.digitalPassportTrusteeMappings === undefined ? undefined : (value.digitalPassportTrusteeMappings === null ? null : (value.digitalPassportTrusteeMappings as Array<any>).map(DigitalPassportTrusteeMappingToJSON)),
    };
}

